import script from "./PosterSlideshow.vue?vue&type=script&setup=true&lang=js"
export * from "./PosterSlideshow.vue?vue&type=script&setup=true&lang=js"

import "./PosterSlideshow.vue?vue&type=style&index=0&id=21ddcade&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.43_vue@3.5.43_typescript@7.0.2__webpack@5.111.0_postcss@8.5.28_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21ddcade"]])

export default __exports__